import React from "react";
import Select, {components} from 'react-select';
import ArrowDown from "../Icons/ArrowDown";

const DropDownIndicator = props => {
    return (
        <components.DropdownIndicator {...props}>
            <div className="custom-select__dropdown-indicator"><ArrowDown/></div>
        </components.DropdownIndicator>
    )
}

const CustomSelect = (props) => {

    const {
        isSearchable
    } = props;

    return (
        <Select
            { ...props }
            className="custom-select-container text-default"
            classNamePrefix="custom-select"
            isSearchable={!!isSearchable}
            components={{ DropDownIndicator }}
        />
    );
}

export default CustomSelect;
